import { Cell, PersonBlock, useAtSize } from '@fs/zion-ui'
import React from 'react'
import { bool, func, number, oneOfType, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

const personButton = css`
  cursor: pointer;
`

const pipe = css`
  color: #e0e2e2;
`

const yearLabel = css`
  font-weight: bold;
`

const yearDescription = css`
  font-weight: normal;
  color: #999999;
`

export default function BirthYearPersonTile({ person, onClick, inDiscoveryCenter = false }) {
  const atSize = useAtSize()
  const [t] = useTranslation()

  const keyPressHandler = (event) => handlePersonTileKeyPress(event, onClick)

  const { name, surname, gender, portraitThumbnailLink, dob: birthYear } = person

  const blockSize = inDiscoveryCenter ? 'xl' : 'lg'

  return (
    <Cell columns={atSize({ default: 12, md: 6, xl: 4, xxl: 3 })}>
      <div css={personButton} role="button" tabIndex={0} onKeyPress={keyPressHandler} onClick={onClick}>
        <PersonBlock
          size={blockSize}
          name={`${name ?? ''} ${surname ?? ''}`}
          avatarProps={{
            src: portraitThumbnailLink,
            sex: gender,
            monogram: `${name?.[0] ?? ''}${surname?.[0] ?? ''}`,
          }}
          details={PersonBirthTileDetails({ birthYear, t })}
        />
      </div>
    </Cell>
  )
}

function PersonBirthTileDetails({ birthYear, t }) {
  const birthYearDisplay = birthYear || t('aam.year-picker.add-birth-year', 'Add Birth Year')
  return (
    <span>
      <span css={yearLabel}>{birthYearDisplay}</span>
      <span css={pipe}> | </span>
      <span css={yearDescription}>{t('aam.year-picker.birth-year', 'Birth Year')}</span>
    </span>
  )
}

function handlePersonTileKeyPress(event, onClick) {
  if (event.key === 'Enter') {
    onClick()
  }
}

BirthYearPersonTile.propTypes = {
  person: shape({
    name: string,
    surname: string,
    gender: string,
    portraitThumbnailLink: string,
    birthYear: oneOfType([string, number]),
  }),
  onClick: func,
  inDiscoveryCenter: bool,
}
